export const baseRoute: string = 'https://staging-api.thecrowdangel.com';
export const baseApiRoute: string = baseRoute + '/api';
export const googleAnalyticsTrackingId: string = 'UA-27967141-1';



// WEBPACK FOOTER //
// ./src/resources/const.tsx